import { duration } from "../../assets/mecom/js/format.mjs";

export function timeDuration(minutes, precise = false) {
    if (!Number.isFinite(minutes) || minutes < 0) return "—";
    if (!precise) {
        if (minutes > 0 && minutes < 0.5) return "<1 min";
        const rounded = Math.round(minutes);
        return rounded ? duration(rounded) : "0 min";
    }
    // A gap above five minutes must never appear as exactly five minutes.
    const seconds = Math.ceil(minutes * 60 - 1e-7);
    const wholeMinutes = Math.floor(seconds / 60), remainder = seconds % 60;
    if (!wholeMinutes) return seconds ? `${seconds} s` : "0 min";
    return `${duration(wholeMinutes)}${remainder ? ` ${remainder} s` : ""}`;
}

export function hoursDuration(hours) {
    return timeDuration(Number.isFinite(hours) ? hours * 60 : null);
}

export function dayDurations(report) {
    const { ore_presenza: presence, ore_lavorate: work, ore_non_lavorate: idle } = report;
    const result = { presence: hoursDuration(presence), work: hoursDuration(work), idle: hoursDuration(idle) };
    if (![presence, work, idle].every(n => Number.isFinite(n) && n >= 0)) return result;
    if (Math.abs(presence - work - idle) > 1e-6) return result;
    // Round the total and work first; display the remainder as idle so the
    // three displayed durations reconcile, without changing the API values.
    const idleMinutes = Math.round(presence * 60) - Math.round(work * 60);
    result.idle = idleMinutes === 0 && idle > 0 ? "<1 min" : timeDuration(idleMinutes);
    return result;
}

export function daySummary(report) {
    const values = [report.ore_presenza, report.ore_lavorate, report.ore_non_lavorate];
    if (!values.every(Number.isFinite)) return "Riepilogo della giornata non disponibile: dati non valutabili.";
    const times = dayDurations(report);
    return `${times.presence} di presenza, ${times.work} di attività, ${times.idle} di fermi.`;
}
